import { Component, OnInit } from '@angular/core';
import { LoanService } from './loans.service';
import { Loan } from './loans';

declare var $: any;

@Component({
  selector: 'zest-loans',
  templateUrl: './loans.component.html',
  styleUrls: ['./loans.component.scss']
})
export class LoansComponent implements OnInit {

  viewMode = 'Active';
  public pastLoans: Loan[];
  public inArrears: Loan[];
  public active: Loan[];
  public paidOff: Loan[];
  public cancelled: Loan[];
  public ongoingLoans: Loan[];
  public fetchingData = false;
  public showLoanCards = true;

  constructor(private loanService: LoanService) { }

  ngOnInit() {
    this.loanService.getOnGoingLoans().subscribe(result => {
      this.inArrears = result.filter(item => item.Status === 'InArrears');
      this.active = result.filter(item => item.Status === 'Active');
      const sorted = [];
      sorted.push(...this.inArrears, ...this.active);
      this.ongoingLoans = sorted;
      if (this.ongoingLoans.length > 0) {
        this.ongoingLoans.forEach(loan => {
          this.loanService.getMambuLoan(loan.LoanExternalId || loan.ExternalId).subscribe(mambuResponse => {
            loan.mambuId = mambuResponse.MambuLoanId;
            this.fetchingData = false;
          });
        });
      } else {
        this.fetchingData = false;
      }
    }, error => {
      this.ongoingLoans = [];
      this.fetchingData = false;
    });
    this.loanService.getPastLoans().subscribe(result => {
      this.paidOff = result.filter(item => item.Status === 'PaidOff');
      this.cancelled = result.filter(item => item.Status === 'Cancelled');
      const pastLoanSorted = [];
      pastLoanSorted.push(...this.paidOff, ...this.cancelled);
      this.pastLoans = pastLoanSorted;
      if (this.pastLoans.length > 0) {
        this.pastLoans.forEach(loan => {
          this.loanService.getMambuLoan(loan.LoanExternalId || loan.ExternalId).subscribe(mambuResponse => {
            loan.mambuId = mambuResponse.MambuLoanId;
            this.fetchingData = false;
          });
        });
      } else {
        this.fetchingData = false;
      }
    }, error => {
      this.pastLoans = [];
      this.fetchingData = false;
    });
  }

  hideLoanCard(value) {
    this.showLoanCards = value;
  }
  triggerSMS() {
    setTimeout(() => {
      $('#triggersmsModal').modal('open');
      this.loanService.triggerSMSForPayment().subscribe();
    });
  }
  closeModal() {
    setTimeout(() => {
      $('#triggersmsModal').modal('close');
    });
  }
}
